export default __webpack_public_path__ + "static/minimalist-resume-86c775b9f98ebe8d14da5451089b58c4.png";